import { render } from "./RolesSection.vue?vue&type=template&id=f7d4088a"
import script from "./RolesSection.vue?vue&type=script&lang=js"
export * from "./RolesSection.vue?vue&type=script&lang=js"

import "./RolesSection.vue?vue&type=style&index=0&id=f7d4088a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__